import { createActionConst } from '../../../../utils/action.utils';

const MEETING_BOARD_NAMESPACE = 'MEETING_BOARD';

export const GET_MEETING_BOARDS = createActionConst(MEETING_BOARD_NAMESPACE, 'GET_MEETING_BOARDS');

export const STORE_MEETING_BOARDS = createActionConst(MEETING_BOARD_NAMESPACE, 'STORE_MEETING_BOARDS');
export const CLEAR_MEETING_BOARDS = createActionConst(MEETING_BOARD_NAMESPACE, 'CLEAR_MEETING_BOARDS');

/***BOARDS***/
export const CREATE_BOARD = createActionConst(MEETING_BOARD_NAMESPACE, 'CREATE_BOARD');
export const UPDATE_BOARD = createActionConst(MEETING_BOARD_NAMESPACE, 'UPDATE_BOARD');
export const DELETE_BOARD = createActionConst(MEETING_BOARD_NAMESPACE, 'DELETE_BOARD');
export const SAVE_BOARD_ORDER = createActionConst(MEETING_BOARD_NAMESPACE, 'SAVE_BOARD_ORDER');
export const DND_BOARD = createActionConst(MEETING_BOARD_NAMESPACE, 'DND_BOARD');
export const SAVE_BOARD_SOCKET = 'saveBoards';
export const DELETE_BOARD_SOCKET = 'deleteBoards';

/***BOARDLISTS***/
export const CREATE_BOARD_LIST = createActionConst(MEETING_BOARD_NAMESPACE, 'CREATE_BOARD_LIST');
export const UPDATE_BOARD_LIST = createActionConst(MEETING_BOARD_NAMESPACE, 'UPDATE_BOARD_LIST');
export const DELETE_BOARD_LIST = createActionConst(MEETING_BOARD_NAMESPACE, 'DELETE_BOARD_LIST');
export const MOVE_BOARD_LIST = createActionConst(MEETING_BOARD_NAMESPACE, 'MOVE_BOARD_LIST');
export const SAVE_BOARD_LIST_ORDER = createActionConst(MEETING_BOARD_NAMESPACE, 'SAVE_BOARD_LIST_ORDER');
export const DND_BOARD_LIST = createActionConst(MEETING_BOARD_NAMESPACE, 'DND_BOARD_LIST');
export const SAVE_BOARD_LIST_SOCKET = 'saveTaskType';
export const DELETE_BOARD_LIST_SOCKET = 'deleteTaskType';
